/* eslint-disable no-nested-ternary */
import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Button, Glyphicon, Table } from 'react-bootstrap'
import swal from 'sweetalert2'
import dayjs from 'dayjs'

import SubadminRow from './SubadminRow'
import AddSubadminBox from '../AddSubadminBox'
import { translate } from '../../../common/utils'
import { createDocument, removeDocument, updateDocument } from '../actions'

type Props = {
  admin: {
    type: String,
    user: {
      _id: String,
      image: String,
      organization: String,
      password: String,
      email: String,
      access_token: String,
      subadmins: Array<{
        _id: String,
        name: String,
        phone: String,
        terminals: [String],
        password: String,
      }>,
    },
  },
  terminals: Array<{ _id: String, name: String, email: String, area: String }>,
  createSubadmin: Function,
  modifySubadmin: Function,
  deleteSubadmin: Function,
}

const defaultSortDirection = 1

const SubadminContainer = ({ admin, terminals, createSubadmin, modifySubadmin, deleteSubadmin }: Props) => {
  const [showAddSubadminBox, setShowAddSubadminBox] = useState(false)
  const [sortProperty, _setSortProperty] = useState('name')
  const [sortDirection, setSortDirection] = useState(defaultSortDirection)

  const setSortProperty = (property) => {
    if (property === sortProperty) setSortDirection(sortDirection * -1)
    else _setSortProperty(property)
  }

  const sortedSubadmins = admin.user.subadmins
    ? [...admin.user.subadmins].sort((a, b) => {
        if (sortProperty === 'lastActive') {
          if (!a.lastActive) return 1
          if (!b.lastActive) return -1

          if (new Date(a.lastActive).getTime() < new Date(b.lastActive).getTime()) return sortDirection
          if (new Date(a.lastActive).getTime() > new Date(b.lastActive).getTime()) return sortDirection * -1
        }

        const aProp = (a[sortProperty] || '').toLowerCase()
        const bProp = (b[sortProperty] || '').toLowerCase()
        if (aProp < bProp) {
          return sortDirection
        }
        if (aProp > bProp) {
          return sortDirection * -1
        }
        return 0
      })
    : []

  return (
    <div>
      <Button onClick={() => setShowAddSubadminBox(!showAddSubadminBox)} className="add-lock-btn" bsSize="small" block>
        <Glyphicon glyph="glyphicon glyphicon-plus" /> &nbsp; Lägg till ny lokaladmin
      </Button>
      {showAddSubadminBox && (
        <AddSubadminBox
          addSubadmin={(subadmin, selectedTerminals) => {
            createSubadmin(subadmin, selectedTerminals).then((data) => {
              if (!data.isAxiosError) {
                setShowAddSubadminBox(false)
              }
            })
          }}
          deleteSubadmin={deleteSubadmin}
          availableTerminals={terminals}
        />
      )}

      <h3 style={{ marginTop: 40 }} className="sub-title">
        Lokaladmin
      </h3>
      <Table responsive style={{ backgroundColor: 'white' }}>
        <thead>
          <tr>
            <th></th>
            <th onClick={() => setSortProperty('name')}>
              <div style={{ float: 'left' }}>{sortProperty === 'name' ? sortDirection < 0 ? <Glyphicon glyph="glyphicon glyphicon-arrow-up" /> : <Glyphicon glyph="glyphicon glyphicon-arrow-down" /> : <Glyphicon glyph="glyphicon glyphicon-sort" />}</div>
              Namn
            </th>
            <th>Tillgång</th>
            <th onClick={() => setSortProperty('lastActive')}>
              <div style={{ float: 'left' }}>{sortProperty === 'lastActive' ? sortDirection < 0 ? <Glyphicon glyph="glyphicon glyphicon-arrow-up" /> : <Glyphicon glyph="glyphicon glyphicon-arrow-down" /> : <Glyphicon glyph="glyphicon glyphicon-sort" />}</div>
              Senast aktiv
            </th>
            {admin.user && admin.user.settings && admin.user.settings.k2enabled === true ? <th>{translate('k2username')}</th> : null}
          </tr>
        </thead>
        <tbody>
          {sortedSubadmins.map((subadmin) => (
            <SubadminRow key={subadmin._id} subadmin={subadmin} terminals={terminals} updateSubadmin={modifySubadmin} deleteSubadmin={deleteSubadmin} />
          ))}
        </tbody>
      </Table>
    </div>
  )
}

const mapState = (state) => ({
  admin: state.collectionData.admin,
})

const mapDispatch = (dispatch) => ({
  createSubadmin: (subadmin, terminals) => dispatch(createDocument('subadmin', { subadmin, terminals })),
  modifySubadmin: (subadmin, terminals) => dispatch(updateDocument('subadmin', subadmin._id, { subadmin, terminals })),
  deleteSubadmin: async (subadmin) => {
    const { value } = await swal.fire({
      title: `Är du säkert på att du vill ta bort ${subadmin.email} som lokaladmin?`,
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#006e78',
      cancelButtonColor: '#CE4547',
      confirmButtonText: 'Ja',
      cancelButtonText: 'Nej!',
    })

    if (!value) return false

    dispatch(removeDocument('subadmin', subadmin._id, subadmin))
  },
})

export default connect(
  mapState,
  mapDispatch
)(SubadminContainer)
